import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult, WrappedItemsResult } from './types';

const farmsApi = {
  getAll(params?: cyrian.api.farms.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.farms.Farm[]>> {
    return request({
      method: 'get',
      url: '/farms',
      params,
    });
  },
  getOne(id: number): ApiResponse<WrappedResult<cyrian.api.farms.Farm>> {
    return request({
      method: 'get',
      url: `/farms/${id}`,
    });
  },
  create(data: cyrian.api.farms.FarmParams): ApiResponse<WrappedResult<cyrian.api.farms.Farm>> {
    return request({
      method: 'post',
      url: '/farms',
      data,
    });
  },
  update(id: number, data: Partial<cyrian.api.farms.FarmParams>): ApiResponse<WrappedResult<cyrian.api.farms.Farm>> {
    return request({
      method: 'patch',
      url: `/farms/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/farms/${id}`,
    });
  },
};

export default farmsApi;
